import { colors } from 'tailwind-config/tokens';

export function getColor(color: string): string {
  const colorValue = colors[color]?.value || colors['charcoal-default'].value;
  return Array.isArray(colorValue) ? colorValue.join('') : colorValue;
}
